// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._MkSkYHYNU9NMu {
  height: 100%;
}
.eryMJsaUqJClPI {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: var(--ds-space-050, 4px) var(--ds-space-150, 10px) 36px var(--ds-space-150, 10px);
  transition: padding 0.2s ease-in-out;
  background: var(--ds-surface, #ffffff);
}
.eryMJsaUqJClPI .Q78OVr4uaG9yT9,
.eryMJsaUqJClPI .nvHz4641qDjYeC {
  position: relative;
  height: 100%;
}
.eryMJsaUqJClPI .nvHz4641qDjYeC {
  border-radius: var(--ds-border-radius-400, 16px);
}
.eryMJsaUqJClPI.iTKynfT8zWRJMZ {
  bottom: var(--ds-space-800, 64px);
}
.eryMJsaUqJClPI.Y85QQu2amx0rm2 {
  padding: var(--ds-space-0, 0);
}
.eryMJsaUqJClPI.Y85QQu2amx0rm2 .nvHz4641qDjYeC {
  border-radius: unset;
}
@media print {
  .eryMJsaUqJClPI {
    flex-direction: column;
  }
}
`, ""]);
// Exports
export var manager = `_MkSkYHYNU9NMu`;
export var splitscreen = `eryMJsaUqJClPI`;
export var content = `Q78OVr4uaG9yT9`;
export var inboxContent = `nvHz4641qDjYeC`;
export var tabs = `iTKynfT8zWRJMZ`;
export var single = `Y85QQu2amx0rm2`;
export default ___CSS_LOADER_EXPORT___;
